<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between bg-primary text-on-primary modal_header">
        <div class="col">
            <div class="text-lg font-medium">Move</div>
            <div *ngIf="!multiItems" class="text-sm font-small">{{data.name}}</div>
            <div *ngIf="multiItems" class="text-sm font-small"></div>
        </div>
        <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-col flex-auto gap-6 px-4 sm:px-6 py-8 sm:pb-6 overflow-y-auto">
        <!-- Instructions -->
        <div class="instruction-alert flex items-start gap-2 p-3 rounded-lg border">
            <mat-icon
                class="icon-size-5 mt-0.5 text-blue-500 dark:text-blue-400"
                svgIcon="dms-custom:info-circle">
            </mat-icon>
            <div class="flex flex-col">
                <span class="title">
                    Instructions
                </span>
                <span class="description">
                    Select a folder destination
                </span>
            </div>
        </div>

    <!-- Compose form -->
    <form class="flex flex-col flex-auto gap-6" [formGroup]="moveItemForm">
        <!-- Hidden input to divert focus -->
        <input #hiddenInput type="text" style="position: absolute; opacity: 0; pointer-events: none; height: 0;">

        <div class="flex flex-col w-full gap-6">
        <!-- Search -->
        <div class="w-full sm:min-w-80">
            <mat-form-field
                class="w-full"
                [subscriptSizing]="'dynamic'">
                <mat-icon
                    matPrefix
                    [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                <input
                    matInput
                    preventAutofocus
                    [formControl]="searchControl"
                    [matAutocomplete]="matAutocomplete"
                    [placeholder]="'Search...'"
                    [(ngModel)]="inputValue"
                    (ngModelChange)="onValueChanged($event)"
                    (keydown)="onKeydown($event)">
            </mat-form-field>
            <mat-autocomplete
                class="max-h-128 mt-1 rounded"
                [autoSelectActiveOption]="true"
                [disableRipple]="true"
                #matAutocomplete="matAutocomplete">
                <mat-option
                    class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                    *ngIf="assets && !assets.length&&!isLoading">
                    No results
                </mat-option>
                <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="isLoading ">
            Searching
            </mat-option>
                    <ng-container *ngFor="let asset of assets; trackBy: trackByFn">
                        <mat-option class="relative py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover" (click)="Navigate(asset)">
                            <div class="flex items-center flex-grow"  >
                                <div class="col-8 flex justify-center items-center gap-2">
                                    <div class="file-icon relative flex flex-0 items-center justify-center ml-2 mr-2">
                                        <mat-icon  class="icon-size-5 opacity-80 text-yellow-400" [svgIcon]="'heroicons_outline:folder'"></mat-icon>
                                    </div>
                                    <div matTooltip="{{asset.name}}"> <!---->
                                        <!-- DO NOT TRUNCATE THE FILENAME -->
                                        <div class="flex flex-col">
                                            <span class="font-semibold leading-tight"> {{asset?.name}}</span>
                                            <span class="leading-tight"> {{asset.createdBy | fullName}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 flex justify-center items-center absolute right-4">
                                    <div class="row flex ">
                                        <mat-icon class="icon-size-4" svgIcon="feather:link"></mat-icon>
                                    </div>
                                </div>
                            </div>
                        </mat-option>
                    </ng-container>
            </mat-autocomplete>
        </div>
        <!-- Search - END-->

        <!-- Folder Lists -->

        <div class="flex flex-col gap-6 col">
            <div class="flex items-center move-nav-top">
                <div class="mr-1" *ngIf="paths.length > 1">
                    <button
                        (click)="goOneLevelUp()"
                        mat-icon-button
                        matTooltip="Go Up">
                        <mat-icon 
                            class="icon-size-5"
                            svgIcon="heroicons_outline:arrow-left"></mat-icon>
                    </button>
                </div>
                <div>
                    <button class="move-target-folder flex items-center font-medium my-1 px-2.5 py-1 me-2" *ngIf="(paths.length>1)"
                        matTooltip="{{paths[paths.length-1]?.name}}">
                        <mat-icon
                            class="icon-size-5 mr-2"
                            [color]="'primary'"
                            svgIcon="heroicons_outline:folder"></mat-icon>
                       {{paths[paths.length-1]?.name}}
                    </button>
                    <span *ngIf="!(paths.length>1) && !this.isWebComponent"
                        class="move-target-folder font-medium me-2 px-2.5 py-1 text-sm">
                        My Drive
                    </span>
                    <span *ngIf="!(paths.length>1) && this.isWebComponent"
                        class="move-target-folder my-1 font-medium me-2 px-2.5 py-1 text-sm"
                        matTooltip="{{paths[paths.length-1]?.name}}">
                        {{paths[paths.length-1]?.name}}
                    </span>
                </div>
            </div>
            <!--Folder List - START -->
            <div 
                class="folder-list-container flex-0 h-full"
                fuseScrollbar
                [fuseScrollbarOptions]="folderListScrollbarOptions">
                <div class="folder-list-container-inner col">
                    <ng-container *ngFor="let folder of folders; let i = index; trackBy:trackByFn">
                        <div 
                            matRipple 
                            class="folder-list-item" 
                            [ngClass]="{'selected': folder.id === selectedDestination?.id}"
                            (click)="setDestination(folder)">
                            <div class="file-icon relative flex flex-0 items-center justify-center ml-2 mr-2">
                                <mat-icon class="icon-size-4 folder-icon" svgIcon="heroicons_outline:folder"></mat-icon>
                            </div>
                            <!--[matTooltip]="folder.name"-->
                            <button 
                                color="accent"
                                class="folder-name truncate"
                                (click)="drillDown(folder); $event.stopPropagation()">{{folder.name}}
                            </button>
                            <mat-icon class="folder-follow icon-size-4" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                            <div class="folder-selected-indicator">
                                <mat-icon class="icon-size-6 text-primary" svgIcon="heroicons_outline:check-badge"></mat-icon>
                            </div>
                        </div>
                    </ng-container>
                     <!-- Empty State View -->
                    <div *ngIf="folders.length === 0" class="empty-state">
                        <!-- You can customize this part as needed -->
                        <div class="empty-state-content">
                            <mat-icon class="icon-size-6 empty-state-icon" svgIcon="heroicons_outline:folder-open"></mat-icon>
                            <p>No subfolders to display</p>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf=" paths.length>0">
                <div class="flex items-center justify-start ps-3 space-x-2 w-full">
                    <ng-container *ngFor="let path of paths; let last = last;">
                        <button class="flex items-center flex-grow-0 bg-transparent">
                        <ng-container *ngIf="!last">
                            <a *ngIf="path.name==='My Drive' && !this.isWebComponent"  class="text-primary cursor-pointer"  (click)="Navigate(path)">{{path.name}}</a>
                            <a *ngIf="path.name!=='My Drive'" class="text-primary cursor-pointer" (click)="Navigate(path)" >{{path.name}}</a>
                        </ng-container>
                        <ng-container *ngIf="last">
                            <div matTooltip="{{path.name}}">{{path.name}}</div>
                        </ng-container>
                        <ng-container *ngIf="!last">
                            <mat-icon
                            class="fuse-vertical-navigation-item-arrow icon-size-4"
                            [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                        </ng-container>
                    </button>
                    </ng-container>
                </div>
            </ng-container>
            <!--Folder List - END -->
        </div>
        </div>
    </form>
    </div>

    <!-- Actions/Footer -->
    <div class="move-actions flex sm:flex-row sm:items-center px-6 border-t border-gray-200 h-20 justify-between">
        <button class="move-cancel-btn border mr-2" [color]="'transparent'"
        mat-stroked-button
        (click)="cancel()">
            Cancel
        </button>
        <div class="flex items-center gap-2">
            <button
                class="move-copy-btn"
                mat-flat-button
                matButtonName="copy"
                [color]="'primary'"
                (click)="CopyItemDialog()"
                [disabled]="!selectedDestination">
                <mat-icon class="icon-size-4" svgIcon="dms-custom:copy"></mat-icon>
                <span class="ps-2">Copy</span>
            </button>
            <button
                class="move-move-btn"
                mat-flat-button
                matButtonName="move"
                [color]="'primary'"
                (click)="moveItemDialog()"
                [disabled]="!selectedDestination">
                <mat-icon class="icon-size-4" svgIcon="dms-custom:move"></mat-icon>
                <span class="ps-2">Move</span>
            </button>
        </div>
    </div>
</div>
<ngx-loading class="inline" [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>